import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  MenuItem,
  Select,
  Typography,
  styled,
  Button,
  Tooltip,
} from "@mui/material";
import { toast } from "react-toastify";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import {
  DataTable,
  ProgressBarWithColors,
  SmoothModal,
} from "../../../components";
import { Iconify } from "../../../utilities";
import { useAAFFs } from "../../../hooks";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import FiltrosAAFF from "../../../components/filtros/filtrosAAFF";
import NoVisitadoAAFF from "../../../components/noVisitadoAAFF";
import noVisitada from "../../../icons/noVisitada.svg";
import notaNV from "../../../icons/notaNV.svg";
import { Link } from "react-router-dom";
import {
  updateComentsDetailsCaes
} from "../../../services";

import { useLocation, useNavigate } from 'react-router-dom';
import { useRecogerURLParamsFiltros, construirURLParamsFiltros } from './../../../functions/parametrosURL/funcionesParamsURL';
import { FaEye } from "react-icons/fa";
import criticalWarning from "../../../icons/criticalWarning.svg";

// Motivos de no visita se definen dentro del componente para usar traducciones

const ColorButton = styled(Button)(() => ({
  color: "white",
  backgroundColor: "#92004D",
  "&:hover": {
    backgroundColor: "#92004D",
  },
  alignItems: "center",
}));

const AAFF = () => {
  const { t } = useTranslation(['aaff', 'properties', 'common']);

  const motivosNoVisita = [
    t('noVisitReasons.noWantRenewal'),
    t('noVisitReasons.notStartYet'),
  ];

  const user = useContext(UsuarioContext);

  const {filtrosIniciales} = useRecogerURLParamsFiltros();
  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [recargar, setRecargar] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [comentario, setComentario] = useState(motivosNoVisita[0]);
  const [selectedAAFF, setSelectedAAFF] = useState(null);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const { loading, data, fetchData } = useAAFFs();

  // Suma de visitadas / comunidades de los AAFF visibles en la pagina actual
  const totalesComunidadesPagina = (data?.rows ?? []).reduce(
    (totales, row) => ({
      visitadas: totales.visitadas + (row.visitadas || 0),
      comunidades: totales.comunidades + (row.comunidades || 0),
    }),
    { visitadas: 0, comunidades: 0 }
  );


  // const handleOpenNewTab = ({ nif }) => {
  //   if (!nif) return;
  //   window.open(`aaff/${nif}/comunidades`, "_blank");
  // };

  // const handlePagination = ({ offset, limit }) => {
  //   const { id } = user
  //   // setPagination({ page: offset, limit });
  //   fetchData({ offset, limit, filtros: busqueda });
  // };

  const handleOpenModal = (id) => {
    setSelectedAAFF(id);
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setSelectedAAFF(null);
  };

  const navigate = useNavigate();
  const location = useLocation();

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  }

  const comunidadesRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.admin'),
      overrideFunc: (data, row) => (
        <Link to={"/aaff/" + row.nif + "/comunidades"}>
          {data}
        </Link>
      ),
    },
    // {
    //   id: "fechaEncargo",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "FECHA ENCARGO",
    // },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('columns.province'),
    },

    {
      id: "communityNumbers",
      numeric: false,
      disablePadding: false,
      label: t('fields.numCommunities'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        <Typography>
          {row.visitadas} /{row.comunidades}
        </Typography>
      ),
    },
    {
      id: "communityPercent",
      numeric: false,
      disablePadding: false,
      label: t('properties:columns.completed'),
      overrideFunc: (data, row) => (

        <ProgressBarWithColors
          value={
            (row.visitadas / (row.comunidades || 1)) * 100
          }
          label={
            parseFloat(
              ((row.visitadas / (row.comunidades || 1)) * 100).toFixed(2)
            ) + "%"
          }
        />
      ),
    },
    {
      id: "propCaducadas",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data) => (
        <>
          {data ?
            <Tooltip title={t('tooltips.expiredCommunities')} arrow>
              <img src={criticalWarning} width={15} alt={t('tooltips.expiredCommunities')} />
            </Tooltip>
            : null}
        </>
      ),
    },
    {
      id: "noVisitada",
      numeric: true,
      disablePadding: false,
      label: t('properties:columns.noVisit'),
      noObjeto:true,
      overrideFunc: (data, row) => (
        <>
          <NoVisitadoAAFF aaff={row} nif={row.nif} />
        </>
      ),
    },

  ];

  useEffect(() => {
    setRecargar(false);
  }, [recargar]);

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros)
    setBusquedaActiva(true);
    // fetchData();
  }

  const handleSubmitMotivo = async () => {
    const data = {
      id: selectedAAFF,
      motivo: comentario
    };
    

    try {

      await updateComentsDetailsCaes(data);

      closeModal();
      toast.success(t('common:messages.savedSuccessfully'), {
        autoClose: true
      });
    } catch (error) {

      console.error("Error al guardar los datos:", error);
      toast.error(t('common:messages.error'), {
        autoClose: true
      });
    }
  };


  return (
    <>
      <SmoothModal open={openModal} onClose={closeModal}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Typography variant="h5" fontWeight={"bold"}>
            {t('properties:noVisit.reason')}
          </Typography>

          <Box sx={{ width: "90%" }} >
            <Select native name="motivoNoVisita" id="motivoNoVisita" style={{ textTransform: 'uppercase' }} onChange={(e) => setComentario(e.target.value)} defaultValue={comentario}>
              <option value=""></option>
              {motivosNoVisita.map(motivo => {
                return (
                  <option key={motivo} value={motivo}>
                    {motivo}
                  </option>
                );
              })}
            </Select>
          </Box>

          <Box display={"flex"} flexDirection={"row"} gap={2}>
            <ColorButton onClick={handleSubmitMotivo}>
              <Typography>{t('common:actions.save')}</Typography>
            </ColorButton>
            <Button onClick={closeModal}>{t('common:actions.cancel')}</Button>
          </Box>
        </Box>
      </SmoothModal>
      <BreadCrumb
        rutas={[{ path: "/aaff", label: t('title') }]}
        style={{ margin: "0 10px" }}
      />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('title').toUpperCase()}
          </div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <FiltrosAAFF onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data?.rows}
                isLoading={loading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data?.current_page}
                meta={data?.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={t('messages.noAaff')}
                resumenPie={
                  user.rol === "TECH_COOR"
                    ? `${t('fields.numCommunities')}: ${totalesComunidadesPagina.visitadas}/${totalesComunidadesPagina.comunidades}`
                    : undefined
                }
              />
            </Box>
          </Box>
        </div>
      </div>

    </>
  );
};

export default withRouter(AAFF);
